<template>
  <div :class="['list-wrap', moduleName]">
    <!-- de小店产品列表title -->
    <h3 v-if="moduleName == 'de-product-classify'">{{ moduleTitle }}</h3>
    <!-- de小店产品列表title -->

    <!-- 传入预设的3or4列 不传就重新写 -->
    <ul :class="listCName">
      <!-- product item循环外层 -->
      <li
        v-for="item in listContent"
        :key="item.id"
        :class="listContent.length <= 3 ? 'mb' : ''"
      >
        <div class="img-wrap">
          <!-- 点击img后的link 可接收item下imgLink isScale url title -->
          <a :href="item.imgLink" target="_blank">
            <img
              :class="{ scale: isScale }"
              :src="item.url"
              :alt="item.title"
            />
          </a>

          <!-- product item 的按钮 可接收item下btnLink-->
          <a
            v-if="storeName.DE_s"
            class="btn-wrap"
            :href="item.btnLink"
            target="_blank"
          >
            <button>
              {{ item.title }}
            </button>
          </a>
        </div>

        <!-- list的描述外层 DE_s不用-->
        <div v-if="!storeName.DE_s" class="product-discription-wrap">
          <a
            :href="item.moreLink ? item.moreLink : item.imgLink"
            target="_blank"
          >
            <h3>{{ item.title }}</h3>
          </a>
          <!-- FR的产品描述 暂时没用 -->
          <span v-if="item.discription">{{ item.discription }}</span>

          <!-- ee的产品分类链接 和头部导航内容重复 设计不合理 -->
          <div v-if="item.secondaryMenu" class="list-secondary-menu">
            <a
              :href="i.link"
              v-for="(i, index) in item.secondaryMenu"
              :key="index"
              >{{ i.name }}
            </a>
          </div>

          <a
            :href="item.moreLink"
            target="_blank"
            :class="[
              item.discription || item.secondaryMenu ? '' : 'mt',
              'more',
            ]"
          >
            <slot name="more"></slot>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "product",
  props: {
    moduleName: {
      type: String,
      required: false,
    },
    moduleTitle: {
      type: String,
      required: false,
    },
    listCName: {
      type: String,
      required: false,
    },
    listContent: {
      type: Array,
      required: true,
    },
    isScale: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
};
</script>

<style type="" lang="less" scoped>
.list-wrap {
  // @media (min-width: 576px) {
  //   &:first-child {
  //     .mt(3rem);
  //   }
  // }
  @media (max-width: 576px) {
    width: 90%;
    .mx(auto);
    &:not(:first-child) {
      .mt;
    }
  }
  .img-wrap {
    img {
      width: 100%;
    }
  }
  // de_s=======================================
  &.specials {
    @media (min-width: 576px) {
      &:first-child {
        .mt(0);
      }
      background-color: @neutralColor;
      .py(1.8rem);
    }
    .three-column {
      @media (min-width: 576px) {
        width: 940px;
        .mx(auto);
        > li {
          flex: 0 0 30%;
        }
      }
      @media (max-width: 576px) {
        > li {
          align-self: stretch;
          &:not(:last-child) {
            .mb;
          }
          img {
            .wh;
          }
        }
      }
    }
    .img-wrap {
      position: relative;
      button {
        width: 50%;
        .py(1rem);
        .bg-c(rgba(0, 0, 0, 0.7), #fff);
        .fz;
        .t-t(uppercase);
        .cur;
        .gd(0.6s);
        .t-ell;
        &:hover {
          .bg-c(rgba(87, 197, 160, 0.8));
        }
      }
    }
    .btn-wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      text-align: center;
    }
  }
  &.de-product-classify {
    background-color: @secondaryColor;
    .py(1rem);
    > h3 {
      .t-t;
      .fz;
      .fw(400);
      color: @neutralColor;
    }
    // .img-wrap {
    //   .btn-wrap {
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     button {
    //       .bg-c(@neutralSecondaryColor);
    //     }
    //   }
    // }
    @media (min-width: 576px) {
      > h3,
      ul {
        width: 940px;
        justify-content: flex-start;
        .mx(auto);
        > li {
          max-width: 30%;
          flex: 0 0 30%;
          &:not(:nth-child(3n + 1)) {
            .ml(5%);
          }
          &:not(:nth-child(-n + 3)) {
            .my(1.5rem);
          }
        }
      }
      > h3 {
        .mt;
      }
      > ul {
        .pt(1.2rem);
        .border-B(#bcb5a7);
      }
      .img-wrap {
        > a {
          overflow: hidden;
        }
        // img {
        //   width: 100%;
        // }
        button {
          z-index: 100;
          display: block;
          width: 100%;
          .py(0.6rem);
          .gd(0.5s);
          .cur;
          .fz;
          .bg-c(@neutralSecondaryColor);
          &:hover {
            .bg-c(rgba(87, 197, 160, 0.8));
          }
        }
      }
      .mb {
        .mb(1.5rem);
      }
      &:last-child {
        .pb(3rem);
      }
    }
    @media (max-width: 576px) {
      > h3 {
        text-align: center;
        .mb;
      }
      // 3列移动端变一行2列
      > ul {
        .flex-wrap(space-between, center, wrap);
        .px(4%);
        > li {
          flex: 0 0 46%;
          max-width: 46%;
          .mt(0);
        }
      }
      &:last-child {
        .mb;
      }
      .img-wrap {
        text-align: center;
        > .btn-wrap {
          .bg-c(@neutralSecondaryColor);
          .mb(1rem);
          &:active {
            .bg-c;
          }
          button {
            .t-ell;
            color: inherit;
          }
        }
      }
      // .product-discription-wrap {
      // .mb;
      // }
    }
  }
  // &.specials,
  // &.de-product-classify {
  //   .img-wrap {
  //     position: relative;
  //   }
  //   .btn-wrap {
  //     position: absolute;
  //   }
  // }
  // de_s=======================================

  &.ee-product-list {
    @media (min-width: 576px) {
      width: 90%;
      .mx(auto);
      > ul {
        > li {
          flex: 0 0 32%;
        }
      }
      .product-discription-wrap {
        .px(2rem);
        > a {
          &:first-child {
            align-self: stretch;
          }
        }
        h3 {
          .fz(1.4rem);
        }
        .list-secondary-menu {
          .fw;
        }
        .more {
          .fz(1rem);
          .fw;
          .mb;
        }
      }
    }
    h3 {
      border-width: 2px;
      .lh;
      .t-t(uppercase);
      .my;
    }
    li {
      background-color: #fff;
    }
    @media (max-width: 576px) {
      li {
        &:not(:first-child) {
          .mt;
        }
      }
      .product-discription-wrap {
        .px;
        .mb;
      }
    }
  }
  &.ee-p-list-main {
    @media (min-width: 576px) {
      width: 85%;
      .mx(auto);
    }
  }
}
.three-column,
.four-column,
.five-column {
  li {
    div {
      overflow: hidden;
      a {
        display: block;
        .cur;
      }
    }
    .img-wrap {
      .wh;
    }
    img.scale {
      .gd(0.4s);
      &:hover {
        opacity: 0.8;
        transform: scale(1.1);
      }
    }
    a {
      max-width: 100%;
      align-self: flex-start;
    }
    h3 {
      .mt;
      .fw(400);
      .border-B;
      .t-t(uppercase);
      @media (min-width: 576px) {
        .fz;
      }
      @media (max-width: 576px) {
        .fz(0.8rem);
      }
    }
    span {
      white-space: normal;
    }
    span.more {
      .t-t(uppercase);
      .fz(0.6rem);
      color: @primaryColor;
    }
    .product-discription-wrap {
      .flex-wrap(initial, initial, initial, column);
    }
  }
  .list-secondary-menu {
    .mb(0.5rem);
    a {
      .t-t;
      .lh(2rem);
      .fz(1rem);
      color: @regularText;
      &:hover,
      &:active {
        text-decoration: underline;
        color: @primaryColor;
      }
    }
  }
}
.three-column {
  @media (min-width: 576px) {
    .flex-wrap(space-between, center, wrap);
  }
  @media (max-width: 576px) {
    .flex-wrap(initial, center, initial, column);
    > li {
      img.scale {
        .wh(100%, 150px);
      }
    }
    > li {
      &:not(:last-child) {
        .product-discription-wrap {
          .mb;
        }
      }
    }
  }
  li {
    h3 {
      color: @primaryColor;
    }
    &:not(:nth-child(-n + 3)) {
      .mt();
    }
  }
}
.four-column,
.five-column {
  @media (max-width: 576px) {
    .flex-wrap(space-between, center, wrap);
    li {
      max-width: 45%;
      flex: 0 0 45%;
      &:not(:nth-child(-n + 2)) {
        .my();
      }
    }
  }
}
.four-column {
  @media (min-width: 576px) {
    .flex-wrap(initial, center, wrap);
    li {
      max-width: 23%;
      flex: 0 0 23%;
      &:not(:nth-child(4n + 1)) {
        .ml(2.666666%);
      }
      &:not(:nth-child(-n + 4)) {
        .my();
      }
    }
  }
  li {
    color: #67686d;
  }
  &:not(:last-child) {
    .mb;
  }
  img {
    .wh;
  }
  .product-discription-wrap {
    .px(2em);
    h3 {
      .t-ell;
    }
    > span:not([class="more"]) {
      .my(1.5em);
      .lh(2.5em);
      width: 70%;
    }
    > a.mt {
      .mt;
    }
  }
}
.five-column {
  @media (min-width: 576px) {
    .flex-wrap(initial, center, wrap);
    li {
      max-width: 18%;
      flex: 0 0 18%;
      &:not(:nth-child(5n + 1)) {
        .ml(2.5%);
      }
      &:not(:nth-child(-n + 5)) {
        .my();
      }
    }
  }
  .product-discription-wrap {
    > a:not([class="more"]) {
      align-self: center;
      &:hover {
        text-decoration: underline;
        &,
        > h3 {
          color: @primaryColor;
        }
      }
    }
    h3 {
      .t-t;
      color: @regularText;
      border: none;
    }
  }
}
</style>
